// extracted by mini-css-extract-plugin
module.exports = {"content":"CurrentGuide_style_content__hTj75"};